import { t as e } from "../utils-DiFe-_ei.js";
import { Button as t } from "./button.js";
import "../button-C8zrAH2m.js";
import { t as n } from "../calendar-Bk83OIIY.js";
import { r, t as i } from "../calendar-BLyd2Htq.js";
import { Popover as a, PopoverContent as o, PopoverTrigger as s } from "./popover.js";
import "../popover-CcWt3azL.js";
import "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
//#region src/foundations/date-range-picker/date-range-picker.tsx
function u({ id: u, value: d, onChange: f, className: p, placeholder: m = "Pick a date range" }) {
	let h = d?.from && d?.to ? `${r(d.from, "MMM d, yyyy")} – ${r(d.to, "MMM d, yyyy")}` : d?.from ? `${r(d.from, "MMM d, yyyy")} – …` : m;
	return /* @__PURE__ */ l(a, { children: [/* @__PURE__ */ c(s, {
		asChild: !0,
		children: /* @__PURE__ */ l(t, {
			id: u,
			variant: "outline",
			size: "sm",
			className: e("justify-start gap-2 rounded-lg font-normal", !d?.from && "text-muted-foreground", p),
			children: [/* @__PURE__ */ c(n, { className: "size-4 shrink-0" }), /* @__PURE__ */ c("span", { children: h })]
		})
	}), /* @__PURE__ */ c(o, {
		className: "w-auto p-0",
		align: "end",
		"aria-label": "Select date range",
		children: /* @__PURE__ */ c(i, {
			mode: "range",
			selected: d,
			onSelect: f,
			numberOfMonths: 1,
			autoFocus: !0
		})
	})] });
}
//#endregion
export { u as DateRangePicker };

//# sourceMappingURL=date-range-picker.js.map